<template>
  <header class="site-header" :class="{ scrolled, 'on-hero': onHero, 'menu-open': open }">
    <div class="wrap nav">
      <router-link to="/" class="brand">EIKA<span class="dot">.</span></router-link>
      <nav class="nav-links" :class="{ open }" :aria-hidden="isMobile && !open ? 'true' : null">
        <router-link to="/" @click="close">How We Help</router-link>
        <router-link to="/services" @click="close">Our Approach</router-link>
        <router-link to="/projects" @click="close">Projects</router-link>
        <router-link to="/about" @click="close">Our Craft</router-link>
        <router-link to="/contact" class="nav-cta" @click="close">Enquire</router-link>
      </nav>
      <button
        class="menu-btn"
        :class="{ 'is-open': open }"
        :aria-label="open ? 'Close menu' : 'Open menu'"
        :aria-expanded="open ? 'true' : 'false'"
        @click="open = !open"
      >
        {{ open ? "✕" : "☰" }}
      </button>
    </div>
    <div class="nav-backdrop" :class="{ show: open }" aria-hidden="true" @click="close"></div>
  </header>
</template>

<script>
export default {
  name: "TheNav",
  data() {
    return { scrolled: false, open: false, isMobile: false };
  },
  computed: {
    // Every page opens on a dark hero image behind the nav (except the
    // plain-cream 404), so the nav starts with light text until scrolled.
    onHero() {
      return this.$route.name !== "not-found";
    },
  },
  mounted() {
    this.onScroll();
    this.onResize();
    window.addEventListener("scroll", this.onScroll, { passive: true });
    window.addEventListener("resize", this.onResize, { passive: true });
    window.addEventListener("keydown", this.onKeydown);
  },
  unmounted() {
    window.removeEventListener("scroll", this.onScroll);
    window.removeEventListener("resize", this.onResize);
    window.removeEventListener("keydown", this.onKeydown);
    document.body.classList.remove("nav-open"); // never strand a locked page
  },
  watch: {
    $route() {
      this.open = false;
    },
    open(isOpen) {
      // Stop the page scrolling behind the panel.
      document.body.classList.toggle("nav-open", isOpen);
    },
    isMobile(mobile) {
      // Resizing to desktop while the panel is open would leave body locked.
      if (!mobile && this.open) this.open = false;
    },
  },
  methods: {
    onScroll() {
      this.scrolled = window.scrollY > 40;
    },
    onResize() {
      this.isMobile = window.innerWidth <= 900;
    },
    onKeydown(e) {
      if (e.key === "Escape" && this.open) this.open = false;
    },
    close() {
      this.open = false;
    },
  },
};
</script>
